import BaseAPIService from '../base/base-api-service';
import OrdersModel from 'src/model/orders.model';
import { ITrackingInfo } from 'src/model/orderline.model';

class OrdersService extends BaseAPIService<OrdersModel> {
  public endpoint: string = '/accountapp/v1/orders';

  constructor() {
    super(OrdersModel);
  }

  public getOrders(
    dateFrom?: string,
    dateTo?: string,
    search?: string,
    sort?: string,
    status?: string,
    size?: number,
    page?: number
  ): Promise<OrdersModel> {
    return this.getOneByParams(this.endpoint, {
      dateFrom,
      dateTo,
      search,
      sort,
      status,
      size,
      page
    });
  }

  public getRecentOrders(size: number = 3): Promise<OrdersModel> {
    return this.getOneByParams(this.endpoint, {
      sort: 'orderDate,DESC',
      size
    });
  }

  public cancelOrder(orderNumber: number, items: { [key: number]: string }) {
    // return Promise.resolve(1);
    return this.doRequest({
      baseURL: this.baseURL,
      data: {
        orderNumber,
        items
      },
      method: 'post',
      headers: {},
      url: `${this.endpoint}/cancellation`
    })
      .then(res => {
        return;
      })
      .catch(err => {
        return err;
      });
  }

  public getTracking(
    lineNumber: number,
    orderDate: number,
    orderNumber: number
  ): Promise<ITrackingInfo> {
    return this.doRequest({
      baseURL: this.baseURL,
      data: {
        lineNumber,
        orderDate,
        orderNumber
      },
      method: 'post',
      headers: {},
      url: '/accountapp/v1/orders/tracking'
    }).then(res => {
      return res.data;
    });
  }
}

const ordersServiceInstance = new OrdersService();
Object.freeze(ordersServiceInstance);

export default ordersServiceInstance;
